<div class="redirect-container">
  <div class="spinner-container">
    <div class="spinner"></div>
    <div class="loading-text">Loading profile information...</div>
  </div>
</div>
